module.exports = __webpack_public_path__ + "img/05f2d87.jpg";